export { default as TradeDetails } from './TradeDetails';
